'use strict';
{
    var app = angular.module('tf.audit', [])

        .controller('auditCtrl', ['$scope', '$state', '$http', '$window', '$stateParams', 'userConfig', 'gridUtil', 'uiGridConstants', 'navSvc', '$localStorage', '$timeout', 'terms', 'uiGridExporterConstants', '$uibModal', function auditController($scope, $state, $http, $window, $stateParams, userConfig, gridUtil, uiGridConstants, navSvc, $localStorage, $timeout, terms, uiGridExporterConstants, $uibModal) {

            $scope.exportCsv = function(){
                $scope.gridApi.exporter.csvExport( uiGridExporterConstants.ALL, uiGridExporterConstants.ALL);
            };

            $scope.exportCsvVisible = function(){
                $scope.gridApi.exporter.csvExport( uiGridExporterConstants.VISIBLE, uiGridExporterConstants.VISIBLE);
            };

            $scope.gridOptions = {
                tableName: 'Account Summary',
                flatEntityAccess: false,
                enableGridMenu: false,
                exporterMenuCsv: false,
                exporterMenuPdf: false,
                showColumnFooter: true,
                enableRowSelection: false,
                enableRowHeaderSelection: false,
                enableGrouping: false,
                enableColumnResizing: true,
                enableFiltering: true,
                saveFilter: true,
                saveSort: true,
                saveScroll: false,
                saveFocus: false,
                minRowsToShow: Math.max(10, Math.floor(($window.innerHeight - 420) / 30)),
                enableVerticalScrollbar: uiGridConstants.scrollbars.ALWAYS,
                enableHorizontalScrollbar: uiGridConstants.scrollbars.NEVER,
                enablePaging: false,
                excessRows: 15,
                exporterCsvFilename: 'auditLog.csv',
                exporterSuppressColumns: ['favourite'],
                onRegisterApi: function (gridApi) {
                    $scope.gridApi = gridApi;
                },
                columnDefs: [
                    {
                        name: 'accountNumber',
                        type : 'string',
                        displayName: 'Account Number',
                        width: '*',
                        headerCellTemplate: 'tf/uiGridHeaderCell',
                        term: terms.accNum,
                        cellTooltip: true,
                        filter: {
                            condition: uiGridConstants.filter.CONTAINS
                        }
                    },
                    { field: 'accountName'},
                    { field: 'lastUpdateDate'},
                    { field: 'lastUpdatetime'},
                    { field: 'lastUpdateUser'},
                    { field: 'status'},
                    { field: 'orderRef',
                        cellTemplate: '<div class="ngCellText ui-grid-cell-contents colt{{$index}}"><a href ng-click="grid.appScope.displayDetails()">{{ row.entity[\'orderRef\'] }}</a></div>',
                    },
                    { field: 'instrument'},
                    { field: 'detail'},
                    { field: 'qtyOrder'},
                    { field: 'qtyWorking'},
                    { field: 'qtyFilled'},
                    { field: 'averagePrice'}
                ]
            };

            $http.get('app/audit/auditOrders.json')
                .then(function(response) {
                    var data = response.data;
                    $scope.gridOptions.data = data;
                });

            $scope.showDetails = false;

            $scope.displayDetails = function() {
                $scope.showDetails = !$scope.showDetails;
            };

            $scope.gridOptionsDetails = {
                flatEntityAccess: false,
                enableGridMenu: false,
                exporterMenuCsv: false,
                exporterMenuPdf: false,
                showColumnFooter: true,
                enableRowSelection: false,
                enableRowHeaderSelection: false,
                enableGrouping: false,
                enableColumnResizing: true,
                enableFiltering: true,
                saveFilter: true,
                saveSort: true,
                saveScroll: false,
                saveFocus: false,
                minRowsToShow: Math.max(10, Math.floor(($window.innerHeight - 420) / 30)),
                enableVerticalScrollbar: uiGridConstants.scrollbars.ALWAYS,
                enableHorizontalScrollbar: uiGridConstants.scrollbars.NEVER,
                enablePaging: false,
                excessRows: 15,
                exporterCsvFilename: 'auditLog.csv',
                exporterSuppressColumns: ['favourite'],
                onRegisterApi: function (gridApi) {
                    $scope.gridApi = gridApi;
                },
                columnDefs: [
                    { field: 'date'},
                    { field: 'time'},
                    { field: 'user'},
                    { field: 'userType'},
                    { field: 'type'},
                    { field: 'where', cellClass : whereCellClass},
                    { field: 'instruction', cellClass : instructionCellClass},
                    { field: 'theo'},
                    { field: 'qtyWorking'},
                    { field: 'qtyFilled'},
                    //{ field: 'limitAmend'},
                    //{ field: 'workingAmend'},
                    { field: 'limitPrice'},
                    { field: 'workingPrice'},
                    { field: 'message'}
                ]
            };

            $scope.openDatePicker = function () {
                var modalInstance = $uibModal.open({
                    templateUrl: 'app/audit/datePicker/datePicker.tpl.html',
                    controller: 'datePickerCtrl as datePickerCtrl',
                    size: 'md'
                });

                //modalInstance.result.then(function (selectedItem) {
                //    $scope.selected = selectedItem;
                //}, function () {
                //});
            };

            function whereCellClass(grid, row, col, rowRenderIndex, colRenderIndex) {
                var value = grid.getCellValue(row,col);
                if (value === "TF") {
                    return 'textTFOrange';
                } else if (value === "Market") {
                    return 'text-aqua';
                } else {
                    return '';
                }
            }

            function instructionCellClass(grid, row, col, rowRenderIndex, colRenderIndex) {
                var value = grid.getCellValue(row,col);
                if (value === "place") {
                    return 'text-aqua';
                } else if (value === "accepted") {
                    return 'textTFOrange';
                } else if (value === "cancelled") {
                    return 'sell';
                } else if (value === "amend") {
                    return 'text-purple';
                } else if (value === "filled") {
                    return 'buy';
                } else {
                    return '';
                }


            }

            $http.get('app/audit/orderDetails.json')
                .then(function(response) {
                    var data = response.data;
                    $scope.gridOptionsDetails.data = data;
                });
        }]);
}







